
export const PAYMENT_TYPE_TEACHER_RATIO = "RATIO";
export const PAYMENT_TYPE_TEACHER_HOUR = "HOUR";

export const DAYCARE_SUBJECT_ID = 13;

export const PAYMENT_STATUS_STUDENT_PENDING = "PENDING";
export const PAYMENT_STATUS_STUDENT_PAID = "PAID";
export const PAYMENT_STATUS_STUDENT_NOT_TALLY = "NOT_TALLY";

export const PAYMENT_STATUS_PAID = "PAID";

//Payment history type
export const PAYMENT_HISTORY_STUDENT = "STUDENT";
export const PAYMENT_HISTORY_TEACHER = "TEACHER";

export const ROLE_ADMIN = "ADMIN";
export const ROLE_EMPLOYEE = "EMPLOYEE";

export const TERMINATED = "TERMINATED";
export const DEACTIVATED = "DEACTIVATED";
export const ACTIVATED = "ACTIVE";